import React from 'react';
import classNames from 'classnames';
var TableRow = function (props) {
    var _a;
    var header = props.header, content = props.content, data = props.data, field = props.field, customRenderContent = props.customRenderContent, customRender = props.customRender, isActive = props.isActive;
    var className = classNames('c-table-card__table-row', (_a = {}, _a[props.customClass] = props.customClass, _a));
    var rowContent = content || data[field];
    var row = data;
    var column = { field: props.field };
    if (customRenderContent) {
        rowContent = props.customRenderContent(row, column, isActive);
    }
    if (customRender) {
        rowContent = customRender(row, column);
        return <div className={className}>{rowContent}</div>;
    }
    return (<div className={className}>
      <span className="c-table-card__table-row-header">{header ? "".concat(header) : ''}</span>
      <span className="c-table-card__table-row-content">{rowContent}</span>
    </div>);
};
export default TableRow;
